import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import AppDrawer from 'app/AppDrawer';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const PrivateRoute = ({ children }: Props) => {
  const isAuth = useAppSelector((state) => state.auth.user?.id);
  const queryString = useLocation().search;
  const path = useLocation().pathname;
  const redirectQuery = `?redirect=${path}`;

  return isAuth ? (
    <AppDrawer>{children}</AppDrawer>
  ) : (
    <Navigate to={`/login/${queryString ? queryString : redirectQuery}`} />
  );
};

export default PrivateRoute;
